import React from 'react'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'

import ApplicationScreenWrapper from './application/ApplicationScreenWrapper'
import LoadingScreen from './application/loading/LoadingScreen'
import { RouterContext } from './contexts'
import { withTracker } from './ga'

// Team
const LazyTeamRoute = React.lazy(() => import('./application/teams/TeamRoute'))

// Player
const LazyPlayerContainer = React.lazy(() =>
  import('./application/player/PlayerContainer'),
)

// Mentor
const LazyGreetingsMentorContainer = React.lazy(() =>
  import('./application/greetings-mentor/GreetingsMentorContainer'),
)

const LazyRegistrationMentorContainer = React.lazy(() =>
  import('./application/registration-mentor/RegistrationContainer'),
)

// Ended
const LazyEndedContainer = React.lazy(() =>
  import('./application/ended/EndedContainer'),
)

const LazyGreetingsEndedContainer = React.lazy(() =>
  import('./application/greetings-ended/GreetingsEndedContainer'),
)

// Discord
const LazyDiscordLink = React.lazy(() =>
  import('./application/discord/discord-link/DiscordLinkContainer'),
)
const LazyDiscordAuthorize = React.lazy(() =>
  import('./application/discord/discord-authorize/DiscordAuthorizeContainer'),
)

// Reports
const LazyGreetingsReportsEndedContainer = React.lazy(() =>
  import('./application/greetings-reports-ended/GreetingsEndedContainer'),
)
// const LazyReportsIdeacaoContainer = React.lazy(() =>
//   import('./application/report-ideacao/RegistrationContainer'),
// )
// const LazyReportsMaoNaMassaContainer = React.lazy(() =>
//   import('./application/report-maonamassa/RegistrationContainer'),
// )
// const LazyReportsFinalContainer = React.lazy(() =>
//   import('./application/report-final/RegistrationContainer'),
// )

// Brasil
// const LazyGreetingsBrasilContainer = React.lazy(() =>
//   import('./application/greetings-brasil/GreetingsBrasilContainer'),
// )
// const LazyReportsBrasilContainer = React.lazy(() =>
//   import('./application/report-brasil/RegistrationContainer'),
// )

const ApplicationRouterContextProvider = withRouter(
  ({ children, ...routerProps }) => (
    <RouterContext.Provider value={routerProps}>
      {children}
    </RouterContext.Provider>
  ),
)

const onRouterUpdate = () => {
  /* global document */
  const main = document.querySelector('main')
  if (main && typeof main.scrollTo === 'function') {
    main.scrollTo(0, 0)
  }
}

const ApplicationRouter = () => (
  <BrowserRouter onUpdate={onRouterUpdate}>
    <ApplicationRouterContextProvider>
      <React.Suspense fallback={<LoadingScreen />}>
        <ApplicationScreenWrapper>
          <Switch>
            <Route
              component={withTracker(LazyPlayerContainer)}
              path="/player/:id"
            />

            <Route
              path="/mentor"
              component={withTracker(LazyGreetingsMentorContainer)}
            />

            <Route
              path="/registration/mentor"
              component={withTracker(LazyRegistrationMentorContainer)}
            />

            <Route
              path="/partner"
              component={withTracker(LazyGreetingsEndedContainer)}
            />

            <Route
              path="/reports/ideacao"
              component={withTracker(LazyGreetingsReportsEndedContainer)}
            />

            <Route
              path="/reports/mao-na-massa"
              component={withTracker(LazyGreetingsReportsEndedContainer)}
            />

            <Route
              path="/brasil"
              component={withTracker(LazyGreetingsReportsEndedContainer)}
            />

            <Route
              path="/reports/final"
              component={withTracker(LazyGreetingsReportsEndedContainer)}
            />

            <Route
              path="/reports/brasil"
              component={withTracker(LazyGreetingsReportsEndedContainer)}
            />

            <Route
              path="/discord/link/:token"
              component={withTracker(LazyDiscordLink)}
            />

            <Route
              path="/discord/authorize"
              component={withTracker(LazyDiscordAuthorize)}
            />

            <Route
              path="/teams/:challenge/:team"
              component={withTracker(LazyTeamRoute)}
            />

            <Route component={withTracker(LazyEndedContainer)} />
          </Switch>
        </ApplicationScreenWrapper>
      </React.Suspense>
    </ApplicationRouterContextProvider>
  </BrowserRouter>
)

export default ApplicationRouter
